import { render, staticRenderFns } from "./downgrade-alert.component.vue?vue&type=template&id=412d2e6e&scoped=true"
import script from "./downgrade-alert.component.vue?vue&type=script&lang=js"
export * from "./downgrade-alert.component.vue?vue&type=script&lang=js"
import style0 from "./downgrade-alert.component.vue?vue&type=style&index=0&id=412d2e6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412d2e6e",
  null
  
)

export default component.exports